export declare type ToolActivationMethod = 'LMB' | 'CONTEXTMENU';
